import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";

export default function WhatsAppButton() {
    const message = "Olá! Vim pelo site e gostaria de atendimento.";
    const whatsappUrl = gerarLinkWhatsApp(message);

    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        // mostra tooltip após 2 segundos
        const timer = setTimeout(() => {
            setShowTooltip(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <style>
                {`
                    @keyframes wa-ring {
                        0% { transform: scale(1); opacity: 0.6; }
                        100% { transform: scale(1.7); opacity: 0; }
                    }

                    @keyframes wa-fadeIn {
                        from { opacity: 0; transform: translateY(10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }

                    .wa-wrapper {
                        position: fixed;
                        bottom: 24px;
                        right: 24px;
                        z-index: 9999;
                    }

                    .wa-button {
                        position: relative;
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        background-color: #25D366;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        box-shadow: 0 8px 24px rgba(37, 211, 102, 0.45);
                        text-decoration: none;
                        transition: transform 0.2s ease, box-shadow 0.2s ease;
                    }
                    .wa-button:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 12px 28px rgba(37, 211, 102, 0.55);
                    }
                    .wa-button::before {
                        content: "";
                        position: absolute;
                        inset: 0;
                        border-radius: 50%;
                        background-color: #25D366;
                        animation: wa-ring 2s ease-out infinite;
                        z-index: -1;
                    }

                    .wa-tooltip {
                        position: absolute;
                        bottom: 76px;
                        right: 0;
                        width: max-content;
                        max-width: 240px;
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;
                        background: #fff;
                        color: #0b243d;
                        padding: 12px 14px;
                        border-radius: 14px;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 12px 30px rgba(11, 36, 61, 0.18);
                        animation: wa-fadeIn 0.3s ease;
                        cursor: pointer;
                    }
                    .wa-tooltip::after {
                        content: "";
                        position: absolute;
                        bottom: -7px;
                        right: 24px;
                        width: 12px;
                        height: 12px;
                        background: #fff;
                        border-right: 1px solid #e5e7eb;
                        border-bottom: 1px solid #e5e7eb;
                        transform: rotate(45deg);
                    }
                    .wa-tooltip-close {
                        flex-shrink: 0;
                        width: 20px;
                        height: 20px;
                        margin: -2px -4px 0 0;
                        padding: 0;
                        border: none;
                        border-radius: 50%;
                        background: transparent;
                        color: #9ca3af;
                        font-size: 16px;
                        line-height: 1;
                        cursor: pointer;
                    }
                    .wa-tooltip-close:hover {
                        background: #f3f4f6;
                        color: #0b243d;
                    }

                    @media (max-width: 600px) {
                        .wa-wrapper {
                            bottom: 16px;
                            right: 16px;
                        }
                        .wa-button {
                            width: 54px;
                            height: 54px;
                        }
                        .wa-tooltip {
                            bottom: 68px;
                            max-width: 200px;
                        }
                    }
                `}
            </style>

            <div className="wa-wrapper">
                {showTooltip && (
                    <div className="wa-tooltip" onClick={() => window.open(whatsappUrl, "_blank", "noopener,noreferrer")}>
                        <div>
                            <div style={{ fontSize: "14px", fontWeight: 700, lineHeight: 1.3 }}>Ficou com alguma dúvida?</div>
                            <div style={{ fontSize: "13px", color: "#6b7280", lineHeight: 1.4, marginTop: "2px" }}>
                                Fale com a gente no WhatsApp!
                            </div>
                        </div>
                        <button
                            type="button"
                            className="wa-tooltip-close"
                            aria-label="Fechar mensagem"
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowTooltip(false);
                            }}
                        >
                            ×
                        </button>
                    </div>
                )}
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wa-button"
                    aria-label="Falar no WhatsApp"
                    onClick={() => setShowTooltip(false)}
                >
                    <FaWhatsapp size={30} />
                </a>
            </div>
        </>
    );
}
